<template>
    <v-dialog
        v-model="display"
        persistent
        width="500"
        >
        <v-card>
            <v-card-title>{{title}}</v-card-title>
            <v-card-subtitle>{{ $t('WORKSHOP_SUBTITLE') }}</v-card-subtitle>
            <v-card-text>
                <v-form
                    v-model="valid"
                    ref="form"
                    >
                    <v-text-field
                        :label="$t('WORKSHOP_NAME')"
                        :rules="rules.name"
                        v-model="form.name"
                        :disabled="uneditableField('name')"
                        ref="name"
                    >
                    </v-text-field>
                    <v-text-field
                        :label="$t('WORKSHOP_CODE')"
                        :rules="rules.code"
                        v-model="form.code"
                        :disabled="uneditableField('code')">
                    </v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    text
                    :disabled="!valid"
                    @click="submitForm"
                    >
                    {{ $t('BTN_SAVE') }}
                    </v-btn>
                <v-btn
                    text
                    @click="closeMe"
                    >
                    {{ $t('BTN_CANCEL') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import inArray from '../utils/inArray';
export default {
    name: "WorkshopDialog",
    props: {
        display: Boolean,
        editMode: Boolean,
        recordId: Number
    },
    data() {
        return {
            form: {
                name: null,
                code: null,
                workshop_id: null
            },
            valid: false,
            rules: {
                name: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG'),
                ],
                code: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG')
                ]
            }
        }
    },
    computed: {
        ...mapState("workshop", ["workshop"]),
        ...mapState("authentication", ["workshopId"]),
        title() {
            if(!this.editMode) return this.$t('WORKSHOP_NEW_TITLE');
            else return this.$t('WORKSHOP_EDIT_TITLE')
        }
    },
    methods: {
        ...mapActions('workshop', ["storeWorkshop", "fetchAll", "updatedWorkshop"]),
        closeMe() {
            // this.$destroy();
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.$emit('closeMe');
        },
        submitForm() {
            if(this.editMode) {
                let payload = {
                    form: this.form,
                    recordId: this.recordId
                }
                this.updatedWorkshop(payload)
                    .then((response) => {
                        this.closeMe();
                        this.fetchAll();
                        this.$emit('success', response.message);
                    })
                    .catch((error) => {
                        this.closeMe();
                        this.$emit('error', error);
                    })
            } else {
                this.storeWorkshop(this.form)
                    .then((response) => {
                        this.closeMe();
                        this.fetchAll();
                        this.$emit('success', response.message);
                    })
                    .catch((error) => {
                        this.$emit('error', error);
                    })
            }
        },
        fillForm() {
            this.form = this.workshop;
        },
        inArray,
        uneditableField(field) {
            return this.form.meta && inArray(field, this.form.meta.uneditable_fields) && this.editMode;
        }
    },
    mounted() {
        this.form.workshop_id = this.workshopId;
    }
}
</script>